import { TuiButton } from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { CreatedRequestResult } from '@core/types';

@Component({
  selector: 'x-request-create-success',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiButton, TranslatePipe],
  templateUrl: './step-success.component.html',
})
export class RequestCreateSuccessComponent {
  readonly createdRequests = input.required<CreatedRequestResult[]>();
  readonly navigateToRequest = output<void>();
  readonly closeDialog = output<void>();
}
